import { useEffect } from "react";

export const preloadVideos = (videoSrcs: string[]) => {
    videoSrcs.forEach((src) => {
        const video = document.createElement("video");
        video.src = src;
        video.preload = "auto";
        video.load();
    });
};

const usePreloadVideos = (videoSrcs: string[]) => {
    useEffect(() => {
        preloadVideos(videoSrcs);
    }, []);
};

export default usePreloadVideos;
